<div class="container mt-4">
  <div class="row mb-3">
    <div class="col-12">
      <ngb-alert
        *ngIf="alert"
        [type]="alert.type"
        (closed)="closeAlert()"
        class="sticky-top"
        [class.bold]="alert.bold"
        style="top: 10px"
        ><span [innerHTML]="alert.message"></span
      ></ngb-alert>
      <h4>QR code preferences for {{ pet.name }}</h4>
      <h6 class="ms-1 mb-3">Chip number {{ qrCodePreferences.chipNumber }}</h6>
      <p class="mb-0">
        Please choose what information you wish to display on {{ pet.name }}’s
        Smart Tag. Please note, the information will be visible to members of
        the public. You can change your preferences at any time.
      </p>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-6">
      <ul class="list-group bio-left">
        <li class="list-group-item large">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Pet Image</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.petImage"
                (change)="
                  qrCodePreferences.petImage = !qrCodePreferences.petImage
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="pet-image-wrapper">
                <div
                  class="pet-image"
                  [ngStyle]="
                    petImage && { 'background-image': 'url(' + petImage + ')' }
                  "
                ></div>
                <div class="pet-image-add-edit">
                  <button
                    class="btn btn-secondary text-white btn-sm"
                    (click)="openImageUploader()"
                  >
                    {{ pet.imageUrl ? "Edit" : "Add" }} image
                  </button>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Keeper name</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.keeperName"
                (change)="
                  qrCodePreferences.keeperName = !qrCodePreferences.keeperName
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          {{ user.name.firstName }} {{ user.name.lastName }}
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Keeper email</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.keeperEmail"
                (change)="
                  qrCodePreferences.keeperEmail = !qrCodePreferences.keeperEmail
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          {{ user.contact.email }}
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Keeper phone no.</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.keeperPhone"
                (change)="
                  qrCodePreferences.keeperPhone = !qrCodePreferences.keeperPhone
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          {{
            user.contact.telephone.length > 0
              ? user.contact.telephone[0].number
              : "Not provided"
          }}
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Keeper address</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.keeperAddress"
                (change)="
                  qrCodePreferences.keeperAddress =
                    !qrCodePreferences.keeperAddress
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          <div class="row">
            <div class="col-5" *ngIf="!userMainAddress">Not provided</div>
            <div class="col-5" *ngIf="!!userMainAddress">
              <div>{{ userMainAddress.line1 }}</div>
              <div *ngIf="userMainAddress.line2">
                {{ userMainAddress.line2 }}
              </div>
              <div>{{ userMainAddress.town }}</div>
              <div>{{ userMainAddress.county }}</div>
              <div>{{ userMainAddress.postcode }}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-md-6">
      <ul class="list-group bio-right">
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Pet name</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.petName"
                (change)="
                  qrCodePreferences.petName = !qrCodePreferences.petName
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          {{ pet.name }}
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Pet type</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.petSpecies"
                (change)="
                  qrCodePreferences.petSpecies = !qrCodePreferences.petSpecies
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          {{ pet.species }}
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Pet breed</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.petBreed"
                (change)="
                  qrCodePreferences.petBreed = !qrCodePreferences.petBreed
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          {{ pet.breed }}
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Pet date of birth</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.petBirthDate"
                (change)="
                  qrCodePreferences.petBirthDate =
                    !qrCodePreferences.petBirthDate
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          {{ getPetDateOfBirth() }}
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Pet gender</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.petGender"
                (change)="
                  qrCodePreferences.petGender = !qrCodePreferences.petGender
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          {{ getPetGender() }}
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Pet neutered</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.petNeutered"
                (change)="
                  qrCodePreferences.petNeutered = !qrCodePreferences.petNeutered
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          {{ pet.neutered ? "Yes" : "No" }}
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-6">
              <h6 class="text-primary">Existing conditions</h6>
            </div>
            <div class="col-6">
              <mat-slide-toggle
                [disabled]="loading || user.accountType === 1"
                class="slider"
                [checked]="qrCodePreferences.petExistingConditions"
                (change)="
                  qrCodePreferences.petExistingConditions =
                    !qrCodePreferences.petExistingConditions
                "
                >Add to QR-Code data</mat-slide-toggle
              >
            </div>
          </div>
          {{
            !!pet.existingConditions && pet.existingConditions.length > 0
              ? pet.existingConditions
              : "-"
          }}
        </li>
      </ul>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-4 offset-md-4 text-center mb-4 mt-4">
      <button
        class="btn btn-success text-white btn-lg w-100"
        [disabled]="loading"
        (click)="save()"
      >
        <fa-icon
          *ngIf="loading"
          [icon]="['fas', 'spinner']"
          [animation]="'spin'"
          class="me-3"
        ></fa-icon>
        {{ loading ? "Saving" : "Save & Preview" }}
      </button>
    </div>
  </div>
</div>
